import { CreateTeamFormFieldValues, TeamMemberRes } from '../types';

const sortByKeyMap = {
  name: 'name',
  email: 'email',
  secondaryEmail: 'secondary_email',
  designation: 'designation',
  linkedinUrl: 'linkedin_url',
  description: 'description'
};

const formatTeamMembers = (data: TeamMemberRes) => {
  const teamMembers = data.data ? [...data.data] : [];

  teamMembers.sort((a, b) => {
    let x = a.order;
    let y = b.order;

    if (x > y) {
      return 1;
    }
    if (x < y) {
      return -1;
    }
    return 0;
  });

  const idSet = new Set(teamMembers.map(obj => obj.order));
  if (teamMembers.length !== idSet.size) {
    return teamMembers.map((teamMember, idx) => ({
      id: teamMember.id,
      name: teamMember.name,
      designation: teamMember.designation,
      description: teamMember.description,
      userId: teamMember.user_id,
      role: teamMember.role,
      email: teamMember.email,
      secondaryEmail: teamMember.secondary_email,
      linkedinUrl: teamMember.linkedin_url,
      coverImagePath: teamMember.cover_image_path,
      profileImagePath: teamMember.profile_image_path,
      experience: '',
      createdAt: teamMember.created_at,
      order: idx
    }));
  }
  return (
    teamMembers?.map(teamMember => ({
      id: teamMember.id,
      name: teamMember.name,
      designation: teamMember.designation,
      description: teamMember.description,
      userId: teamMember.user_id,
      role: teamMember.role,
      email: teamMember.email,
      secondaryEmail: teamMember.secondary_email,
      linkedinUrl: teamMember.linkedin_url,
      coverImagePath: teamMember.cover_image_path,
      profileImagePath: teamMember.profile_image_path,
      experience: '',
      createdAt: teamMember.created_at,
      order: teamMember.order
    })) || []
  );
};

const formatCreateUpdateTeamMemberPayload = (
  data: CreateTeamFormFieldValues
) => {
  return {
    cover_image_path: data.teamMemberCoverImage?.path ?? '',
    description: data.teamMemberDescription?.trim(),
    designation: data.teamMemberDesignation?.trim() || null,
    email: data.teamMemberEmail?.trim() || null,
    linkedin_url: data.teamMemberLinkedInUrl?.trim(),
    name: data.teamMemberName?.trim(),
    profile_image_path: data.teamMemberProfileImage?.path ?? '',
    role: data.teamMemberRole?.trim(),
    secondary_email: data.teamMemberSecondaryEmail?.trim() || null,
    created_at: data.teamMemberCreatedAt ?? '',
    order: data.teamMemberOrder ?? 0
  };
};

export { sortByKeyMap, formatTeamMembers, formatCreateUpdateTeamMemberPayload };
